/**
 * Created by vladislav on 26.08.2021
 */

cleverapps.pool = {
    _pool: {},

    putInPool: function (obj) {
        const ObjClass = obj.constructor;
        const pid = this.getPoolId(ObjClass);

        if (!this._pool[pid]) {
            this._pool[pid] = [];
        }

        obj.unuse && obj.unuse();

        if (ObjClass.PoolLimit === undefined || this._pool[pid].length < ObjClass.PoolLimit) {
            this._pool[pid].push(obj);
        }
    },

    getPoolId: function (objClass) {
        let pid = objClass.prototype.__pid;
        if (!pid) {
            const desc = { writable: true, enumerable: false, configurable: true };
            desc.value = ClassManager.getNewID();
            Object.defineProperty(objClass.prototype, "__pid", desc);
            pid = desc.value;
        }

        if (objClass.GetPoolId) {
            pid = objClass.GetPoolId.call(objClass);
        }
        return pid;
    },

    hasObject: function (objClass) {
        const pid = this.getPoolId(objClass);
        return this._pool[pid] && this._pool[pid].length > 0;
    },

    getFromPool: function (objClass, ...args) {
        if (this.hasObject(objClass)) {
            const key = this.getPoolId(objClass);
            const list = this._pool[key];
            const obj = list.pop();

            obj.reuse && obj.reuse.call(obj, ...args);
            delete obj.stopListeners;
            ComponentMap.detach(obj, AlignmentComponent);

            return obj;
        }
    },

    drainAllPools: function () {
        for (const pid in this._pool) {
            this._pool[pid].forEach((obj) => {
                cc.Base.PerformRecursive(obj, (node) => {
                    node.cleanup();
                });
            });
        }

        this._pool = {};
    }
};